import Axios from 'axios'
import store from '../store'
import strings from '@/strings'

const chartered = {
  getDesk4meUrl(){
    return process.env.VUE_APP_URL_SERVER_BASE_DESK4ME
  },
  getClientIdDesk4me () {
    return store.getters['Client/clientIdDesk4Me']
  },
  getAvailableCharteredBuses() {
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/chartered/names`)
  }
}

export default chartered
